import hooks from '../../../hooks'
import { useQuery } from 'react-query'
import { get } from 'lodash'

const useAvailableRedemptions = () => {
    const { api, endpoints, url } = hooks.useApi()
    const cacheKeys = hooks.useCacheKeys()
    const { data, isLoading } = useQuery(
        cacheKeys.MOBILE_IOS_REDEMPTIONS,
        () => api.get(endpoints.mobileIOSRedemptions)
    )
    return {
        availableRedemptions: get(data, 'available', 0),
        isLoading
    }
}

export default useAvailableRedemptions

